import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CustomTable from "../../components/CustomTable";
import { headDataDocuments } from "../../components/CustomTable/headData";
import {
  typeTicketOptions,
  companyOptions,
  sunatStatusOptions,
  pagoStatusOptions,
  areaOptions,
  typeDocumentOptions,
  initDataUsuarioRimac,
  initDataProveedorDB,
  initDataProveedorContactoMedContactoDB,
  initDataProveedorTerceroDB
} from "../../utils/options";
import Jumpbotron from "../../components/common/Jumpbotron";
import Step from "../../components/common/Step";
import Tab from "../../components/common/Tab";
import { iconDownloadHead } from "../../components/common/icons";
import Input from "../../components/common/Input";
import Select from "../../components/common/Select";
import Button from "../../components/common/Button";
import Radio from "../../components/common/Radio";
import deleteLogo from "../../assets/gl_delete-20.svg";
import InputWithDropdown from "../../components/common/InputWithDropdown";
import InputPicker from "../../components/common/InputPicker";
import { Auth } from "aws-amplify";
import moment from "moment";
import ExcelSchema from "../../components/common/ExcelSchema";
import "./styles.scss";
import { callService } from "../../amplify/callService";
import Modal from "../../components/common/Modal";
import { CONSTANTES } from "../../utils/Constantes";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "../../redux/actions/general";
import TableRimac from "../../components/common/Table/TableRimac";
import {
  iconDownloadUnavailable,
  iconDownload,
  iconFile,
  iconDeleteDropdown,
  iconEdit,
} from "../../components/common/icons";
import Chip from "../../components/common/Chip";
import { getColorByStatusSunat,  converJsonTextReq} from "../../utils/utils";
import { profileUsers, statusUsers } from "../../utils/options";
import InputFile from "../../components/common/InputFile";
import CardItem from "../../components/common/CardItem";
import Alert from "../../components/common/Alert";
import Pagination from "../../components/common/Pagination";
import Checkbox from "../../components/common/Checkbox";
import ProveedoresDatosUbicacion from "../../layouts/ProveedoresDatosUbicacion";
import ProveedoresContacto from "../../layouts/ProveedoresContacto";
import ProveedoresFormaPago from "../../layouts/ProveedoresFormaPago";
import ProveedoresReferencia from "../../layouts/ProveedoresReferencia";
import ProveedoresContactoRimac from "../../layouts/ProveedoresContactoRimac";
import ProveedoresAccionista from "../../layouts/ProveedoresAccionista";
import ProveedoresRepresentanteLegal from "../../layouts/ProveedoresRepresentanteLegal";
import ProveedoresTransparencia from "../../layouts/ProveedoresTransparencia";
import ProveedoresPreguntas from "../../layouts/ProveedoresPreguntas";
import ProveedoresValidacion from "../../layouts/ProveedoresValidacion";
import ProveedoresFinalizar from "../../layouts/ProveedoresFinalizar";
import Validate from "../../utils/Validate";
import {iniciarConfiguracionAPINoAuth} from "../../amplify";
/*
const typesOfAdicFile =
  "image/*, application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/*, audio/*, video/* , text/plain";
*/
const itemsPerPage = 10;

const Proveedores = (props, handleEdit = () => {}) => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState();
  const [paginationData, setPaginationData] = useState({
    totalPages: 5,
  });

  const [data, setData] = useState(null);
  const [indVal, setIndVal] = useState(false);
  const [checkReporte, setCheckReporte] = useState(false);
  const [checkEmision, setCheckEmision] = useState(false);
  const [checkRecepcion, setCheckRecepcion] = useState(true);

  const [isInternalUser, setIsInternalUser] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [reporteData, setReporteData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [globalChecked, setGlobalCheked] = useState(false);
  const [tagBody, setTagBody] = useState("actions2");
  const [tagEmptyBody, setTagEmptyBody] = useState("404");
  const [selectedRow, setSelectedRow] = useState(null);
  const [groups, setGroups] = useState(null);
  const [files, setFiles] = useState([]);
  const [arrAreas, setArrAreas] = useState([]);
  const [emptyModal, setEmptyModal] = useState(false);
  const [paso, setPaso] = useState(0);
  const [pasoActual, setPasoActual] = useState(0);
  const [docReemplazo, setDocReemplazo] = useState("");
  const [username, setUsername] = useState("");
  const [activeTab, setActiveTab] = useState("0");
  const [finalizar, setFinalizar] = useState(false);
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });
  let { token } = useParams();  
  const obtenerFichaProveedorToken = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.obtenerFichaToken.replace('{token}',token));
      console.log("RESPUESTa OBTFICHA:",response);
      if (response.ok && response.data && response.data.payload) {        
        let resp = response.data.payload;                       
        setData({ ...data, ...resp});
        if(resp.idpEstadoRegistro!='PND')
          setFinalizar(true);
        setIndVal(true);
      }else{
        setIndVal(false);
      }
    } catch (ex) {
      console.log("Error al obtener ficha", ex);
    }
  };
  //obtenerFichaProveedorToken();

  const handleChangeReporte = (event) => {
    console.log('============', event)
    setReporteData("");
    setCheckReporte(event.target.checked)
    //if(!event.target.checked) setEmail('');
  };
  const handleChangeEmision = (event) => {
    console.log('============', event);    
    setCheckEmision(event.target.checked);
    if(!event.target.checked){
      setCheckRecepcion(true);
    }
    //if(!event.target.checked) setEmail('');
  };
  const handleChangeRecepcion = (event) => {
    console.log('============', event)
    setCheckRecepcion(event.target.checked);
    if(!event.target.checked){
      setCheckEmision(true);
    }
    //if(!event.target.checked) setEmail('');
  };

  const getDataFromCurrentUser = async () => {
    const currentUser = await Auth.currentAuthenticatedUser();
    console.log("currentUser", currentUser);
    const typeUser = currentUser?.attributes["custom:type_user"];
    const rucUser = currentUser?.attributes["custom:ruc"];
    setUsername(currentUser?.username);
    return { typeUser, rucUser };
  };

  const initialSetup = async () => {
    try{
      const anonymousUser = await Auth.currentCredentials();
      await obtenerFichaProveedorToken();
    }catch(err){
      console.log("ERR:", err);
    }
  };

  useEffect(async() =>  {
    iniciarConfiguracionAPINoAuth();
    await initialSetup();
  },[]);

  useEffect(() => {
    //if (tableData.length > 0) {
    console.log("DATA STATE PASO:",paso);
  }, [paso]);


  const handleChangeCheckBox = (index) => {
    let newList = [...tableData];
    newList[index].checked = !newList[index].checked;
    setTableData(newList);
  };



  const getAreas = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.getArea);
      if (response.ok && response.data && response.data.payload) {
        let areas = response.data.payload.map((el, index) => {
          return {
            value: el.ID,
            text: el.name,
          };
        });
        setArrAreas(areas);
      }
    } catch (ex) {
      console.log("Error al obtener areas", ex);
    }
  };
  const resetAlert = () => {
    setShowAlert({
      show: false,
      title: "",
      message: "",
      type: "",
    });
  };

  const resetMessage = (sec) =>
    setTimeout(() => {
      resetAlert();
    }, sec * 1000);

  const isExistFile = (fileObj) => {
    let existingFileIndex = files.findIndex(
      (f) => f.file.name === fileObj.file.name
    );
    return existingFileIndex;
  };

  const clearFiles = () => {
    let copySelectedRow = { ...selectedRow };
    copySelectedRow.filesAdic = [];
    setSelectedRow(copySelectedRow);
  };

  const deleteFileFromRenderItem = async (itemIndex) => {
    // let listFile = selectedRow.filesAdic.filter((file, index) => index !== itemIndex);
    if (window.confirm("Está seguro seguro de eliminar el archivo elegido?")) {
      const { dateTimeCreation, id } = selectedRow;
      let obj = {
        payload: {
          dateTimeCreation,
          index: itemIndex,
          id,
        },
      };
      dispatch(showLoading());
      let response = await callService(
        "POST",
        CONSTANTES.APIS_PATH.deleteSust,
        obj
      );
      if (response.ok && response.data) {
        let copySelectedRow = { ...selectedRow };
        copySelectedRow.filesAdic = copySelectedRow.filesAdic.filter(
          (file, index) => index !== itemIndex
        );
        setSelectedRow(copySelectedRow);        
        setCurrentPage(new Number(1));
        
      }
      dispatch(hideLoading());
    }
  };

  const downloadSustento = async (item, index) => {
    const { id, filesAdic } = item;
    const sustento = filesAdic[index];
    const { type } = sustento;

    let obj = {
      payload: {
        typeFile: "sustento",
        idData: id,
        index,
        extensionFile: type,
      },
    };
    dispatch(showLoading());
    let response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.getUrlDocs,
      obj
    );
    if (response.ok) {
      var filename = response.data.data.filename;
      fetch(response.data, { method: "GET" })
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          dispatch(hideLoading());
        })
        .catch((err) => {
          console.log("Error: ", err);
          dispatch(hideLoading());
        });
    }
  };

  const handleShowModal = (row, tag) => {
    if (!showModal) setShowModal(true);
    setTagBody(tag);
    if (tag === "actions2") setSelectedRow(row);
    else if (tag === "facturaReemplazo") setSelectedRow(row);
    else if (tag === "delete") setSelectedRow(row);
    else if (tag === "edit") {
      let copy = { ...row };
      copy.profile = profileUsers.filter(
        (profUser) => profUser.text.toLowerCase() === row.profile.toLowerCase()
      )[0];
      copy.status = statusUsers.filter(
        (statusUser) =>
          statusUser.text.toLowerCase() === row.status.toLowerCase()
      )[0];
      setSelectedRow(copy);
    }
  };

  const handleFiles = (newFiles, status) => {
    // console.log("newFiles local", newFiles);
    let copyFiles = [...selectedRow.filesAdic];
    for (const item of newFiles) {
      item["isNew"] = status;
      let indexFile = isExistFile(item);
      if (indexFile >= 0) {
        copyFiles[indexFile] = item;
      } else {
        copyFiles.push(item);
      }
    }
    let copySelectedRow = { ...selectedRow };
    copySelectedRow.filesAdic = copyFiles;
    setSelectedRow(copySelectedRow);
  };

  const handleCloseModal = (value) => {
    setSelectedRow(null);
    setShowModal(value);
  };

  const handleClickModal = async () => {
    if (tagBody === "actions2") {
      if (selectedRow.filesAdic.length > 0) {
        const currentUser = await Auth.currentAuthenticatedUser();
        const rucUser = currentUser?.attributes["custom:ruc"];
        let file = selectedRow.filesAdic.map((elem) => {
          let nameFileUpload =
            elem && elem.file
              ? `${selectedRow.clientDoc}-${selectedRow.docNumber}-${elem.file.name}`
              : "";
          let obj = {
            filename: elem && elem.file ? nameFileUpload : "",
            typeFile: elem && elem.file ? elem.file.type : "",
            data:
              elem && elem.file
                ? elem.file.content.slice(elem.file.content.indexOf(",") + 1)
                : "",
          };
          return obj;
        });

        let objData;
        let nextFiles = [];
        let response = {};

        for (const itemFile of file) {
          if (itemFile.filename || itemFile.typeFile || itemFile.data) {
            nextFiles.push(itemFile);
          }
        }

        if (file.length > 0) {
          objData = {
            payload: {
              ID: selectedRow.id,
              dateTimeCreation: new Date(
                selectedRow.broadcast
              ).getMilliseconds(),
              files: nextFiles,
            },
          };
        }

        if (objData.payload.files.length > 0) {
          dispatch(showLoading());
          response = await callService(
            "POST",
            CONSTANTES.APIS_PATH.uploadSust,
            objData
          );
        } else {
          setShowAlert({
            show: true,
            title: "Aviso",
            message: "No se encontraron documentos para cargar",
            type: "error",
          });
          resetMessage(5);
        }

        if (response.data && response.data.type === 0) {          
          setCurrentPage(new Number(1));          
        } else {
          console.log(
            "🚀 ~ file: index.jsx ~ line 250 ~ error update tabla",
            response
          );
          setShowAlert({
            show: true,
            title: "Aviso",
            message: "Ocurrió un error",
            type: "error",
          });
          resetMessage(5);
        }
        dispatch(hideLoading());
        console.log(
          "🚀 ~ file: index.jsx ~ line 313 ~ handleClickModal ~ response",
          response
        );

        if (response) setSelectedRow(null);
        handleCloseModal(false);
      } else {
        setShowAlert({
          show: true,
          title: "Aviso",
          message: "No se encontraron documentos para cargar",
          type: "error",
        });
        resetMessage(5);
      }
    } else if (tagBody === "edit") {
      handleEdit(selectedRow);
      handleCloseModal(false);
    } else if (tagBody == "delete"){
      const {id, dateTimeCreation} = selectedRow;

      const body = {
        payload: {         
          ID: id,
          dateTimeCreation: dateTimeCreation,
          usuarioEliminacion: username,
          canalEliminacion: "Portal"
        }
      };
      try {
        dispatch(showLoading());
        const response = await callService(
          "POST",
          CONSTANTES.APIS_PATH.deleteDoc,
          body
        );
        dispatch(hideLoading());
        console.log(response);
        // type == 0 => ok , type == 1 => error
        if (response.ok && response.data && response.data.type === "0") {
          setShowAlert({
            show: true,
            title: "Correcto",
            message: response.data.message || "se eliminó el documento",
            type: "success",
          });
          resetMessage(5);
          handleCloseModal(false);
          
          setCurrentPage(new Number(1));          
        } else {
          const mesaje = response?.data?.message || "Error al eliminar";
          setShowAlert({
            show: true,
            title: "Error",
            message: mesaje,
            type: "error",
          });
          resetMessage(5);
        }

        // handleSearchEndpoint();
      } catch (ex) {
        dispatch(hideLoading());
      }
    } else if (tagBody === "facturaReemplazo") {
      const { dateTimeCreation, docNumber, clientDoc, id,docType } = selectedRow;

      const body = {
        payload: {
          newDoc: docReemplazo,
          docType : docType,
          oldDoc: docNumber,
          ruc: clientDoc,
          ID: id,
          dateTimeCreation,
          userName: username,
        },
      };
      try {
        dispatch(showLoading());
        const response = await callService(
          "POST",
          CONSTANTES.APIS_PATH.replaceNumDoc,
          body
        );
        dispatch(hideLoading());
        console.log(response);
        // type == 0 => ok , type == 1 => error
        if (response.ok && response.data && response.data.type === "0") {
          setShowAlert({
            show: true,
            title: "Correcto",
            message: response.data.message || "se actualizó el registró",
            type: "success",
          });
          resetMessage(5);
          handleCloseModal(false);
                    
          setCurrentPage(new Number(1));          
        } else {
          const mesaje = response?.data?.message || "Error al actualizar";
          setShowAlert({
            show: true,
            title: "Error",
            message: mesaje,
            type: "error",
          });
          resetMessage(5);
        }

        // handleSearchEndpoint();
      } catch (ex) {
        dispatch(hideLoading());
      }
    }
  };

  const handleChange = (name, value) => {
    let jsonAd = {};
    if(name=='idpClasificacion'){
      jsonAd.idPais = 'PE';
    }
    value = value.toUpperCase ? value.toUpperCase() : value;
    setData({ ...data, [name]: value, ...jsonAd });
  };
  const handleChangePaso = (value) => {
    setActiveTab(value+1);
    if(value+1>paso)
      setPaso(value+1);
  };
  
  const handlePasoActual = (value) => {
      setPasoActual(value);
  };

  const handleDate = (name, objDate) => {
    console.log("ERROR FORMAT:", objDate);
    const newDate = objDate.hasErrorFormat ? new Date() : objDate.value;
    console.log("SETDATA:", { ...data, [name]: newDate } );
    setData({ ...data, [name]: newDate });
  };

  const handleClean = async () => {
    //await initialSetup();
  };

  const handleActualizarFicha = async (req) => {
    //req = converJsonTextReq(req); 
    let payload = {
      ...Validate.extraerAtributos(initDataProveedorDB,data),
      ...req
    };
    setData({...data,...payload});
    const fetchObj = {
      payload: payload,
    };
    dispatch(showLoading());
    const response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.actualizarFichaProveedor,
      fetchObj
    );
    console.log('response.data', response.data);    
    console.log("RESPONSE:", response);
    if (response.ok && response.data) {
      setEmptyModal(true);
    }else if(response.networkError){
      setTableData([]);
      setEmptyModal(true);
      setTagEmptyBody("Network");
    }else {
      console.log("Error fetching data => ", response.message);
      setTableData([]);
      setEmptyModal(true);
      setTagEmptyBody("404");
    }
    //medio contacto
    dispatch(showLoading());
    req.medioContacto = req.medioContacto || [];
    req.medioContacto = req.medioContacto.map(obj=>({...obj, idpTipoContacto: "CONEM"}));
    req.referencia = req.referencia || [];
    req.referencia = req.referencia.map(obj=>({...obj, idpTipoContacto: "CONRE"}));
    req.contactoRimac = req.contactoRimac || [];
    req.contactoRimac = req.contactoRimac.map(obj=>({...obj, idpTipoContacto: "CONRI"}));
    let medCont = req.medioContacto.concat(req.referencia).concat(req.contactoRimac);

    medCont.map(async obj=>{
      let response = await callService(
        "POST",
        CONSTANTES.APIS_PATH.actualizarFichaMedioContacto,
        {
          payload: {...initDataProveedorContactoMedContactoDB, ...obj, idProveedor: data.idProveedor},
        }
      );      
      console.log('response.data medio contacto', response.data);    
      console.log("RESPONSE med contacto:", response);
      if (response.ok && response.data) {
        setEmptyModal(true);
      }else if(response.networkError){
        setTableData([]);
        setEmptyModal(true);
        setTagEmptyBody("Network");
      }else {
        console.log("Error fetching data => ", response.message);
        setTableData([]);
        setEmptyModal(true);
        setTagEmptyBody("404");
      }
    });
    //formaPago
    dispatch(showLoading());
    req.formaPago = req.formaPago || [];
    req.formaPago.map(async obj=>{
      let response = await callService(
        "POST",
        CONSTANTES.APIS_PATH.actualizarFichaFormaPago,
        {
          payload: {...obj, idProveedor: data.idProveedor},
        }
      );      
      console.log('response.data forma pago', response.data);    
      console.log("RESPONSE med forma pago:", response);
      if (response.ok && response.data) {
        setEmptyModal(true);
      }else if(response.networkError){
        setTableData([]);
        setEmptyModal(true);
        setTagEmptyBody("Network");
      }else {
        console.log("Error fetching data => ", response.message);
        setTableData([]);
        setEmptyModal(true);
        setTagEmptyBody("404");
      }
    });
    //terceros
    req.accionista = req.accionista || [];
    req.accionista = req.accionista.map(obj=>({...obj, idpTipoTercero: "ACC"}));
    req.representante = req.representante || [];
    req.representante = req.representante.map(obj=>({...obj, idpTipoTercero: "REP"}));
    req.grupoEconomico = req.grupoEconomico || [];
    req.grupoEconomico = req.grupoEconomico.map(obj=>({...obj, idpTipoTercero: "GRP"}));
    let tercero = req.accionista.concat(req.representante).concat(req.grupoEconomico);

    tercero.map(async obj=>{
      if(obj.prcCapital)
        obj.prcCapital=Number(obj.prcCapital);
      if(obj.aniosCargo)
        obj.aniosCargo=Number(obj.aniosCargo);
      let response = await callService(
        "POST",
        CONSTANTES.APIS_PATH.actualizarFichaTercero,
        {
          payload: {...initDataProveedorTerceroDB, ...obj, idProveedor: data.idProveedor},
        }
      );      
      console.log('response.data tercero', response.data);    
      console.log("RESPONSE tercero:", response);
      if (response.ok && response.data) {
        setEmptyModal(true);
      }else if(response.networkError){
        setTableData([]);
        setEmptyModal(true);
        setTagEmptyBody("Network");
      }else {
        console.log("Error fetching data => ", response.message);
        setTableData([]);
        setEmptyModal(true);
        setTagEmptyBody("404");
      }
    });

    //preguntas
    req.preguntas = req.preguntas || [];
    req.preguntast = req.preguntast || [];
    let preg = req.preguntas.concat(req.preguntast);
    preg.map(async obj=>{
      let response = await callService(
        "POST",
        CONSTANTES.APIS_PATH.actualizarFichaPregunta,
        {
          payload: {...obj, idProveedor: data.idProveedor},
        }
      );      
      console.log('response.data preguntas', response.data);    
      console.log("RESPONSE preguntas:", response);
      if (response.ok && response.data) {
        setEmptyModal(true);
      }else if(response.networkError){
        setTableData([]);
        setEmptyModal(true);
        setTagEmptyBody("Network");
      }else {
        console.log("Error fetching data => ", response.message);
        setTableData([]);
        setEmptyModal(true);
        setTagEmptyBody("404");
      }
    });
    dispatch(hideLoading());

    //terceros lista cuadro
    
    let terceroListaCuadro = req.listaCuadro || [];
    terceroListaCuadro = terceroListaCuadro.filter(e=>e.idpTipoTercero!="PRV");
    terceroListaCuadro.map(async obj=>{
      if(obj.prcCapital)
        obj.prcCapital=Number(obj.prcCapital);
      if(obj.aniosCargo)
        obj.aniosCargo=Number(obj.aniosCargo);
      let response = await callService(
        "POST",
        CONSTANTES.APIS_PATH.actualizarFichaTercero,
        {
          payload: {...initDataProveedorTerceroDB, ...obj, idProveedor: data.idProveedor},
        }
      );      
      console.log('response.data tercero', response.data);    
      console.log("RESPONSE tercero:", response);
      if (response.ok && response.data) {
        setEmptyModal(true);
      }else if(response.networkError){
        setTableData([]);
        setEmptyModal(true);
        setTagEmptyBody("Network");
      }else {
        console.log("Error fetching data => ", response.message);
        setTableData([]);
        setEmptyModal(true);
        setTagEmptyBody("404");
      }
    });

    obtenerFichaProveedorToken();
  };
  const handleFinalizarFicha = async (req) => {
    //req = converJsonTextReq(req); 
    let payload = {
      ...Validate.extraerAtributos(initDataProveedorDB,data),
      ...req
    };
    //setData({...data,...payload});
    const fetchObj = {
      payload: payload,
    };
    dispatch(showLoading());
    const response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.finalizarFichaProveedor,
      fetchObj
    );
    console.log('response.data', response.data);    
    console.log("RESPONSE:", response);
    if (response.ok) {
      setFinalizar(true);
      dispatch(hideLoading());
      var filename = response.data.filename;
      fetch(response.data.url, { method: "GET" })
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;          
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    }
    if (response.ok && response.data) {
      setEmptyModal(true);
    }else if(response.networkError){
      setTableData([]);
      setEmptyModal(true);
      setTagEmptyBody("Network");
    }else {
      console.log("Error fetching data => ", response.message);
      setTableData([]);
      setEmptyModal(true);
      setTagEmptyBody("404");
    }    
  };



  const handlePressEnter = (e) => {
    if (e.key === "Enter") {
      setCurrentPage(new Number(1));
    }
  };

  const bodyModal = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">Aviso</h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <h4 className="title-05 margin-bottom-10">
            No se encontro{" "}
            <span className="title-05 color-red">
              <strong>documentos</strong>
            </span>
          </h4>
        </div>
      </div>
    );
  };

  const bodyNetworkModal = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">Aviso</h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <h4 className="title-06 margin-bottom-10">
            Cantidad de datos a buscar no soportada, disminuir rango de busqueda.            
          </h4>
        </div>
      </div>
    );
  };

const bodyInfoSendEmailModal = () => {
  return (
    <div className="content customTable--bodyModal">
      <div className="title">
        <h4 className="title-05 margin-bottom-10">Aviso</h4>
      </div>
      <div className="form--line" />
      <div className="customTable--bodyModal-input">
        <h4 className="title-06 margin-bottom-10">
          Te estamos enviando a tu correo la información solicitada.
        </h4>
      </div>
    </div>
  );
};

  const handleGlobalChecked = () => {
    const newGlobal = !globalChecked;
    setGlobalCheked(newGlobal);
    let lista = tableData.map((item) => {
      return { ...item, ["checked"]: newGlobal };
    });
    setTableData(lista);
  };

  const downloadFile = async (data, extensionFile) => {
    
    if(extensionFile== "pdf" && !((data.files || []).find(x=>x.type=='pdf')))
    {
      console.log("noexiste")
      setShowAlert({
        show: true,
        title: "Aviso",
        message: "No existe el documento",
        type: "error",
      });
      
      resetMessage(5);
      return;
    }
    if(extensionFile== "xml" && !((data.files || []).find(x=>x.type=='xml')))
    {
      setShowAlert({
        show: true,
        title: "Aviso",
        message: "No existe el documento",
        type: "error",
      });
      
      resetMessage(5);
      return;
    }
    let obj = {
      payload: {
        typeFile: "documento",
        idData: data.id,
        extensionFile: extensionFile,
      },
    };
    let response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.getUrlDocs,
      obj
    );
    if (response.ok) {
      var filename = response.data.data.filename;
      fetch(response.data.url, { method: "GET" })
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;          
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    }
  };


  const bodyModalActions2 = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">
            Lista de{" "}
            <span className="title-05 color-red">
              <strong>archivos adicionales</strong>
            </span>
          </h4>
          <h4 className="title-05 margin-bottom-32">
            del documento:{" "}
            <span className="title-05 color-red">
              <strong>
                {selectedRow ? selectedRow.docType : "..."}-
                {selectedRow ? selectedRow.docNumber : "..."}
              </strong>
            </span>
          </h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          {
            <InputFile
              filesDefault={files || []}
              maxSizebyFile={5}
              maxSizeAllFile={15}
              // acceptFiles={typesOfAdicFile}
              labelMessage="Máx. 5 MB por archivo y hasta 15 MB en total. Formatos: Cualquiera menos ejecutables"
              getFiles={(newFiles) => {
                handleFiles(newFiles, true);
              }}
              hideListItems={true}
              multiple
              title={{
                mobile: "Seleccione sus archivos",
                desktop: "Seleccione sus archivos",
              }}
            />
          }

          <div className="d-flex-between margin-bottom-16 margin-top-48">
            <h4 className="title-06">
              Documentos cargados (
              {selectedRow &&
                selectedRow.filesAdic &&
                selectedRow.filesAdic.length}{" "}
              archivo
              {selectedRow &&
                selectedRow.filesAdic &&
                (selectedRow.filesAdic.length > 1 ||
                  selectedRow.filesAdic.length === 0) &&
                "s"}{" "}
              cargado
              {selectedRow &&
                selectedRow.filesAdic &&
                (selectedRow.filesAdic.length > 1 ||
                  selectedRow.filesAdic.length === 0) &&
                "s"}{" "}
              )
            </h4>
            {selectedRow?.filesAdic && selectedRow.filesAdic.length >= 1 && (
              <div>
                <p className="title-07 pointer" onClick={() => clearFiles()}>
                  {iconDeleteDropdown} <span> Limpiar</span>
                </p>
              </div>
            )}
          </div>
          <div>
            {selectedRow && selectedRow.filesAdic
              ? selectedRow.filesAdic.map((f, index) => (
                  <CardItem
                    data={f}
                    deleteAction={() => deleteFileFromRenderItem(index)}
                    DownloadACtion={() => downloadSustento(selectedRow, index)}
                    key={index}
                  />
                ))
              : []}
          </div>
        </div>
      </div>
    );
  };

  const bodyModalDelete = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-32">
           <span className="title-05 color-red">
              <strong>Eliminación </strong>
            </span>del documento:{" "}
            <span className="title-05 color-red">
              <strong>
                {selectedRow ? selectedRow.docType : "..."}-
                {selectedRow ? selectedRow.docNumber : "..."}
              </strong>
            </span>
          </h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <div className="d-flex-between margin-bottom-16 margin-top-48">
            <h4 className="title-06">
              ¿Esta seguro de Eliminar el documento y los archivos adjuntos?
            </h4>            
          </div>         
        </div>
      </div>
    );
  };

  const bodyModalFactReem = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">
            Reemplazo del documento:{" "}
            <span className="title-05 color-red">
              <strong>{selectedRow && selectedRow.docNumber}</strong>
            </span>
          </h4>
          <h4 className="title-05 margin-bottom-32">
            RUC:{" "}
            <span className="title-05 color-red">
              <strong>{selectedRow ? selectedRow.clientDoc : "..."}</strong>
            </span>
          </h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <div className="d-justify-space-between d-flex-column-m w100">
            <div className="documents_criteria_numdocumento">
              <Input
                label="Nuevo documento"
                maxLength="30"
                onChange={(newValue) => setDocReemplazo(newValue)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const bodyModalEdit = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">
            Registro para{" "}
            <span className="title-05 color-red">
              <strong>editar datos de usuario</strong>
            </span>
          </h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <Input
            label="Nombre completo"
            value={
              selectedRow && selectedRow.fullname ? selectedRow.fullname : ""
            }
            onChange={(newValue) => handleChange("fullname", newValue)}
          />
          <Input
            label="Email"
            value={selectedRow && selectedRow.email ? selectedRow.email : ""}
            onChange={(newValue) => handleChange("email", newValue)}
          />
          <Select
            label="Perfil"
            selected={
              selectedRow && selectedRow?.profile ? selectedRow.profile : ""
            }
            onChange={(newValue) => handleChange("profile", newValue)}
            items={profileUsers}
          />
          <Select
            label="Estado"
            selected={
              selectedRow && selectedRow?.status ? selectedRow.status : ""
            }
            onChange={(newValue) => handleChange("status", newValue)}
            items={statusUsers}
          />
        </div>
      </div>
    );
  };
  let indEmpresa = (data && data.idpTipoDocumento=='RUC' && data.numDocumento.substring(0,2)=='20');
  return (    
    <div className="documents d-justify-center padding-bottom-16">     
      <Jumpbotron
        paths={[]}
        titleBlack="REGISTRO Y ACTUALIZACION"
        titleRed="DE PROVEEDORES"
        subTitle="Inicia tu registro"
      />
      <div className="content-grilla">
        <div
          // onSubmit={handleSearch}
          className="documents_criteria w100 margin-bottom-16"
        > {finalizar && 
          <ProveedoresFinalizar dataT={data}></ProveedoresFinalizar>
          }
          {!finalizar && 
          <Step
            activeTab={activeTab}
            options={"Ingresa la ubicación|Ingresa tus datos|Cuentanos mas sobre ti|Ingresa las Referencias|Contactos de Rimac"+(indEmpresa?"|Accionistas|Representante Legal":"")+"|Información complementaria|Preguntas|Valida tu Información"}
            //changeTab={tabQuestions}
            //disabledTab={tabDisabled}
            setActiveTab = {setActiveTab}
            paso = {paso}
            contents={
              <>
                {data && <ProveedoresDatosUbicacion dataT={data} keyIndex = {0} handleActualizarFicha = {handleActualizarFicha}  handleChangePaso={handleChangePaso}></ProveedoresDatosUbicacion>}
                {data && <ProveedoresContacto dataT={data} keyIndex = {1} handleActualizarFicha = {handleActualizarFicha} handleChangePaso={handleChangePaso}></ProveedoresContacto>}
                {data && <ProveedoresFormaPago dataT={data} keyIndex = {2} handleActualizarFicha = {handleActualizarFicha} handleChangePaso={handleChangePaso}></ProveedoresFormaPago>}
                {data && <ProveedoresReferencia dataT={data} keyIndex = {3} handleActualizarFicha = {handleActualizarFicha}  handleChangePaso={handleChangePaso}></ProveedoresReferencia>}
                {data && <ProveedoresContactoRimac dataT={data} keyIndex = {4} handleActualizarFicha = {handleActualizarFicha}  handleChangePaso={handleChangePaso}></ProveedoresContactoRimac>}
                {indEmpresa && <ProveedoresAccionista dataT={data} keyIndex = {5}  handleActualizarFicha = {handleActualizarFicha}  handleChangePaso={handleChangePaso}></ProveedoresAccionista>}
                {indEmpresa &&  <ProveedoresRepresentanteLegal dataT={data} keyIndex = {6} handleActualizarFicha = {handleActualizarFicha}  handleChangePaso={handleChangePaso}></ProveedoresRepresentanteLegal>}
                
                {data && <ProveedoresTransparencia dataT={data} keyIndex = {5+(indEmpresa?2:0)} handleActualizarFicha = {handleActualizarFicha}  handleChangePaso={handleChangePaso} indEmpresa={indEmpresa}></ProveedoresTransparencia>}
                {data && <ProveedoresPreguntas dataT={data} keyIndex = {6+(indEmpresa?2:0)} handleActualizarFicha = {handleActualizarFicha} handleChangePaso={handleChangePaso}></ProveedoresPreguntas>}
                {data && <ProveedoresValidacion dataT={data} keyIndex = {7+(indEmpresa?2:0)} handleFinalizarFicha = {handleFinalizarFicha} handleChangePaso={handleChangePaso} indEmpresa={indEmpresa}></ProveedoresValidacion>}
              </>
            }
          />
          }
        </div>
        {showAlert.show && (
          <Alert
            title={showAlert.title}
            message={showAlert.message}
            type={showAlert.type}
            hasBg={true}
            position="top-right"
            handleClose={() => resetAlert()}
          />
        )}
        {showModal && (
          <Modal
            className="rd--modal-info-files"
            onToggle={(value) => handleCloseModal(value)}
            visible={showModal}
            width={672}
            fullScreenMobile
            redHoverClosed
            onLabelClosed
            max12Padding
            footer={
              <Button primary onClick={() => handleClickModal(false)}>
                {tagBody === "delete"
                ? "Eliminar"
                : "Guardar"}
              </Button>
            }
          >
            {tagBody === "actions2"
              ? bodyModalActions2()
              : tagBody === "facturaReemplazo"
              ? bodyModalFactReem()
              : tagBody === "delete"
              ? bodyModalDelete()
              : bodyModalEdit()}

            {/* {bodyModalActions2()} */}
          </Modal>
        )}
      </div>
    </div>
  );
};

export default Proveedores;